<section class="login-page font-display">
  <div class="login-column login-column--hero">
    <div class="login-hero">
      <div class="login-hero__pattern"></div>
      <div class="login-hero__content">
        <div class="login-hero__top">
          <p class="login-hero__brand">PT Mavens Mitra Perkasa</p>

          <div class="login-hero__logo-wrap">
            <div class="login-hero__logo">
              <img src="logo mavens.png" alt="Logo Mavens" />
            </div>
          </div>
        </div>

        <h1 class="login-hero__welcome">
          Selamat datang<br />
          di aplikasi cash advance<br />
          dan reimbursement
        </h1>
      </div>
    </div>
  </div>

  <div class="login-column login-column--form">
    <div class="login-form-wrap">
      <form
        [formGroup]="form"
        (ngSubmit)="login()"
        class="login-card"
        novalidate
      >
        <p class="login-card__eyebrow">Masuk ke akun</p>
        <h2 class="login-card__title">Selamat datang</h2>
        <p class="login-card__desc">
          Masukkan email dan password untuk mengakses dashboard Anda.
        </p>

        <div class="login-form">
          <div class="form-field">
            <label class="form-field__label" for="login-email">Email</label>
            <input
              id="login-email"
              type="email"
              formControlName="username"
              class="form-field__input"
              [ngClass]="{
                'form-field__input--error':
                  form.get('username')?.invalid && form.get('username')?.touched
              }"
              placeholder="Masukkan email Anda"
              autocomplete="username"
            />
            <span
              *ngIf="
                form.get('username')?.invalid && form.get('username')?.touched
              "
              class="form-field__error"
              >Email wajib diisi</span
            >
          </div>

          <div class="form-field">
            <label class="form-field__label" for="login-password">Password</label>
            <input
              id="login-password"
              type="password"
              formControlName="password"
              class="form-field__input"
              [ngClass]="{
                'form-field__input--error':
                  form.get('password')?.invalid && form.get('password')?.touched
              }"
              placeholder="Masukkan password Anda"
              autocomplete="current-password"
            />
            <span
              *ngIf="
                form.get('password')?.invalid && form.get('password')?.touched
              "
              class="form-field__error"
              >Password wajib diisi</span
            >
          </div>

          <button
            type="submit"
            class="login-submit"
            [disabled]="form.invalid"
          >
            Masuk
          </button>
        </div>
      </form>

      <p class="login-footer">© Digivi 2026 · Mavensnomics v1.0.0</p>
    </div>
  </div>
</section>
